<!--
 * @Author: your name
 * @Date: 2022-04-02 15:04:32
 * @LastEditTime: 2022-04-06 10:25:40
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \src\views\pc\proposal\details.vue
-->
<template>
    <div>
        <div class="Proposal-Heater">
            <div class="Proposal-Heater-w">
                <div class="Proposal-Heater-left clearfix">
                    <div class="Proposal-HeaterImg"></div>
                    <div class="Proposal-HeaterId">
                        <p>Administrator</p>
                        <p>12292736273@gmail.com</p>
                    </div>
                </div>
                <div class="Proposal-Heater-right">
                    <div class="Proposal-Heater-input">
                        <input type="text" name="" placeholder="Search" />
                        <div class="Proposal-Heater-input-mfg"></div>
                        <div class="Proposal-Heater-input-mfg1"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="Theme">
            <div class="Theme-w">
                <div class="Theme-w-h">
                    <ul>
                        <li class="Theme-w-left">
                            <p>#ID</p>
                            <p>Title</p>
                        </li>
                        <li class="Theme-w-center">Status</li>
                        <li class="Theme-w-rigth">
                            <p>Time remaining</p>
                            <p>Total Deposit</p>
                        </li>
                    </ul>
                </div>
                <div>
                    <ul>
                        <li>
                            <p>#66</p>
                            <p>Staking Param Change</p>
                        </li>
                        <li><img src=""></li>
                        <li>
                            <p>30 mins 29 secs left</p>
                            <p>43.000000</p>
                            <p>00</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {};
</script>

<style lang="less" scoped>
    .Proposal-Heater {
        width: 100%;
        padding: 90px 0 10px 0;
        background: #ffffff;
    .Proposal-Heater-w {
        width: 1200px;
        margin: 0 auto;
        padding: 23px 0px 23px 20px;
        background-color: #fff;
        display: flex;
    .Proposal-Heater-left {
        flex: 0 0 50%;
    .Proposal-HeaterImg {
        width: 60px;
        height: 60px;
        border: 1px solid #000;
        box-sizing: border-box;
        float: left;
        margin-right: 30px;
    }
    .Proposal-HeaterId {
        float: left;
        margin-top: 6px;
    p:nth-child(1) {
        font-size: 16px;
        font-family: Poppins-SemiBold, Poppins;
        font-weight: 600;
        color: #2c1d1a;
        line-height: 19px;
        -webkit-background-clip: text;
        margin-bottom: 4px;
        margin-right: 30px;
    }
    p:nth-child(2) {
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: rgba(115, 117, 130, 0.5);
        line-height: 16px;
        -webkit-background-clip: text;
    }
    }
    }
    .Proposal-Heater-right {
        flex: 0 0 50%;
        position: relative;
    .Proposal-Heater-input {
        background: rgba(235, 240, 245, 0.5);
        border-radius: 25px 25px 25px 25px;
    input {
        width: 406px;
        height: 50px;
        border: none;
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: rgba(69, 115, 231, 0.5);
        line-height: 16px;
        -webkit-background-clip: text;
        padding-left: 64px;
    }
    }
    .Proposal-Heater-input-mfg {
        width: 17px;
        height: 17px;
        border: 2px solid #4573e7;
        border-radius: 50%;
        position: absolute;
        top: 16px;
        left: 25px;
    }
    .Proposal-Heater-input-mfg1 {
        width: 2px;
        height: 8px;
        background-color: #4573e7;
        border-radius: 2px;
        transform: rotate(-38deg);
        position: absolute;
        top: 30px;
        left: 39px;
    }
    }
    }
    }
    .Theme {
        width: 100%;
        height: 100%;
        background: #fafafa;
        padding-top: 40px;
    .Theme-w {
        width: 1200px;
        padding: 40px 29px 0 29px;
        background: #fff;
        margin: 0 auto;
    .Theme-w-h {
        border-bottom: 1px solid #e8eaf0;
    ul {
        display: flex;
    li {
        font-size: 14px;
        font-family: Poppins-Medium, Poppins;
        font-weight: 500;
        color: #000000;
        line-height: 16px;
        -webkit-background-clip: text;
    p {
        display: inline-block;
    }
    }
    .Theme-w-left {
        flex: 0 0 30%;
    p:nth-child(1) {
        margin-right: 39px;
    }
    }
    .Theme-w-center {
        flex: 0 0 49%;
    }
    .Theme-w-rigth {
        flex: 0 0 21%;
    p:nth-child(1) {
        margin-right: 47px;
    }
    }
    }

    // .Theme-w-boundary {
       //   width: 100%;
       //   height: 1px;
       //   border-bottom: 1px solid #e8eaf0;
       // }
    }
    }
    }
</style>
